import { IS_DEVELOPMENT } from '@/components/constants/constants';

// MODULE FOR
export const TEAM_LEAGUE_MODULE_FOR = 120;
export const TEAM_LEAGUE_DIVISION_MODULE_FOR = 141;

export const FEATURED_LEAGUES_QUERY_KEY = 'featured-leagues';
export const MLP_STRIP_QUERY_KEY = 'mlp-strip';
export const SCHEDULE_EVENT_MATCHUPS_QUERY_KEY = 'schedule-event-matchups';
export const SCORE_FORMATS_QUERY_KEY = 'score-formats';
export const PLAYER_GRAPH_STATS_QUERY_KEY = 'player-graph-stats';
export const PLAYER_OVERALL_STATS_QUERY_KEY = 'player-overall-stats';
export const PARTNERS_OPPONENTS_STATS_QUERY_KEY = 'partners-opponents-stats';
export const TEAM_PLAYERS_QUERY_KEY = 'team-players';
export const PLAYER_ACTIVITY_QUERY_KEY = 'playerActivity';
export const ACTIVE_TEAMS_QUERY_KEY = 'active-teams';
export const DISTRICTS_INFO_QUERY_KEY = 'districts-info';
export const SYSTEM_USERS_SEARCH_QUERY_KEY = 'system-users-search';
export const SEASON_DIVISION_SUBSTITUTE_PLAYERS_QUERY_KEY = 'season-division-substitute-players';
export const SCHEDULED_EVENTS_QUERY_KEY = 'scheduled-events';
export const TOTAL_TEAM_LEAGUES = 'total-team-leagues';

// TEAM DETAILS API KEYS
export const TEAM_DETAILS_INFO_BANNER_QUERY_KEY = 'team-details-info-banner';
export const TEAM_DETAILS_STATS_INFO_QUERY_KEY = 'team-details-stats-info';
export const TEAM_DETAILS_ROSTER_INFO_QUERY_KEY = 'team-details-roster-info';
export const TEAM_PROFILE_INFO_QUERY_KEY = 'team-profile-info';

export const CAPTAIN_NOTIFICATION_BANNER_QUERY_KEY = 'CAPTAIN_NOTIFICATION_BANNER_QUERY_KEY';
export const TEAMS_OPTIONS_QUERY_KEY = 'TEAMS_OPTIONS_QUERY_KEY';
export const DIVISION_TEAMS_INFO_QUERY_KEY = 'division-teams-info';
export const TEAM_ACTIVITY_QUERY_KEY = 'team-activity';
export const TEAM_PLAYER_ACTIVITY_QUERY_KEY = 'team-player-activity';
export const PLAYER_AVAILABILITY_QUERY_KEY = 'player-availability';
export const PLAYER_SCHEDULE_EVENTS_QUERY_KEY = 'player-schedule-events';
export const PLAYER_SCHEDULE_GAMEDAY_QUERY_KEY = 'player-schedule-gameday';
export const TEAM_LOGOS_QUERY_KEY = 'team-logos';
export const TEAM_EDIT_INFO_QUERY_KEY = 'team-edit-info';

export const MY_TEAM_LEAGUES_QUERY_KEY = 'MY_TEAM_LEAGUES_QUERY_KEY';
export const RECOMMENDED_LEAGUES_QUERY_KEY = 'RECOMMENDED_LEAGUES_QUERY_KEY';

export const FEATURE_FLAGS = {
	ENABLE_NEW_CARDS: IS_DEVELOPMENT,
	ENABLE_PRICING_PAGE: IS_DEVELOPMENT
} as const;

export const LINEUPS_QUERY_KEY = 'LINEUPS_QUERY_KEY';
export const TEAM_LEAGUE_BALL_SELECTION_QUERY_KEY = 'TEAM_LEAGUE_BALL_SELECTION_QUERY_KEY';
